<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <div
      class="sidenav-inner"
      :class="{ 'py-1': orientation !== 'horizontal' }"
      style="margin-top: 60px;"
    >
      <sidenav-menu
        icon="ion ion-md-speedometer"
        :active="isMenuActive('/dashboards')"
        :open="isMenuOpen('/dashboards')"
      >
        <template slot="link-text">Pulpity</template>
        <sidenav-router-link
          v-for="dashboard in dashboards"
          :key="dashboard.id"
          :to="'/dashboard/' + dashboard.id"
          :exact="true"
        >{{ dashboard.name }}</sidenav-router-link>
      </sidenav-menu>
      <sidenav-menu
        icon="ion ion-ios-people"
        :active="isMenuActive('/dashboards')"
        :open="isMenuOpen('/dashboards')"
        v-if="this.hasAccess('UsersList') || this.hasAccess('Role')"
      >
        <template slot="link-text">Użytkownicy</template>
        <sidenav-router-link to="/users" :exact="true" v-if="this.hasAccess('UsersList')">Lista użytkowników</sidenav-router-link>
        <sidenav-router-link to="/replacements" :exact="true" v-if="this.hasAccess('Replacements')">Zastępstwa</sidenav-router-link>
        <sidenav-router-link to="/roles" :exact="true" v-if="this.hasAccess('Roles')">Role</sidenav-router-link>
      </sidenav-menu>
      <!-- <sidenav-router-link icon="ion ion-ios-contact" to="/home" :exact="true">Home</sidenav-router-link> -->
      <sidenav-menu
        icon="ion ion-ios-business"
        :active="isMenuActive('/dashboards')"
        :open="isMenuOpen('/dashboards')"
        v-if="this.hasAccess('Companies')"
      >
        <template slot="link-text">Firmy</template>
        <sidenav-router-link to="/companies" :exact="true">Dane firmowe</sidenav-router-link>
        <sidenav-router-link to="/projects" :exact="true">Projekty IVR</sidenav-router-link>
      </sidenav-menu>
      <sidenav-router-link icon="ion ion-ios-phone-portrait" to="/layouts" :exact="true" v-if="this.hasAccess('Layouts')">Layouts</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-locate" to="/location" :exact="true" v-if="this.hasAccess('Location')">Lokalizacja</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-calendar" to="/tasks" :exact="true" v-if="this.hasAccess('Tasks')">Zadania</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-send" to="/notifications" :exact="true" v-if="this.hasAccess('Notifications')">Powiadomienia</sidenav-router-link>
    </div>
  </sidenav>
</template>
<script>
import Service from "@/services";

import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from "@/vendor/libs/sidenav";

import { isInRole, roles } from "@/utils/helpers";

export default {
  name: "app-layout-sidenav",
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
  },
  data() {
    return {
      roles,
      dashboards: [],
      accesses: []
    };
  },
  props: {
    orientation: {
      type: String,
      default: "vertical"
    }
  },
  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === "horizontal" &&
        (bg.indexOf(" sidenav-dark") !== -1 ||
          bg.indexOf(" sidenav-light") !== -1)
      ) {
        bg = bg
          .replace(" sidenav-dark", "")
          .replace(" sidenav-light", "")
          .replace("-darker", "")
          .replace("-dark", "");
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== "horizontal"
          ? "layout-sidenav"
          : "layout-sidenav-horizontal container-p-x flex-grow-0")
      );
    }
  },
  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return (
        this.$route.path.indexOf(url) === 0 && this.orientation !== "horizontal"
      );
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    hasAccess(resourceName) {
      return (this.accesses.indexOf(resourceName) > -1);
    },
  },
  created() {
    var vm = this;
    Service.get("/Dashboards")
      .then(function(response) {
        if (response.data.length === 0)
          Service.post("/Dashboards", { name: "Dashboard" })
            .then(function(response) {
              vm.dashboards.push(response.data);
            })
            .catch(function(error) {});
        else vm.dashboards = response.data;
      })
      .catch(function(error) {});

    Service.get("/Authentication/AccessCodes")
      .then(function(response) {
        vm.accesses = response.data;
      })
      .catch(function(error) {});
  },
  mounted: function() {
  }
};
</script>
